import { ArrowRightOutlined } from '@ant-design/icons';
import { TipoDomandaDTO } from '@framework/api-client';
import { BrandedPath, generatePath, LinkButton } from '@framework/ui';
import { useTranslation } from 'react-i18next';

export interface IInquiryLinkButtonProps {
  inquiry: TipoDomandaDTO;
  categoryId?: string | null;
}

/**
 * Pulsante "vai alla domanda" dell'item "tipo domanda" della lista delle domande.
 */
export function InquiryLinkButton(props: IInquiryLinkButtonProps) {
  const { inquiry, categoryId } = props;

  const { t } = useTranslation();

  const buttonText = inquiry.flNonInviabile
    ? t(
        'domande.lista.elemento.pulsante.dettaglio-domanda',
        'Vai alla procedura',
      )
    : t('domande.lista.elemento.pulsante.vai-alla-domanda', 'Vai alla Domanda');

  const buttonAriaLabel = buttonText + ' ' + inquiry.titolo;

  const path = (
    categoryId ? `/categoria/:categoryId/domande/:id` : `/domande/:id`
  ) as BrandedPath;

  return (
    <LinkButton
      type="primary"
      size="large"
      aria-label={buttonAriaLabel}
      to={generatePath(path, { id: inquiry.id!, categoryId: categoryId! })}
    >
      {buttonText}
      <ArrowRightOutlined aria-hidden />
    </LinkButton>
  );
}
